var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:[
    _vm.defaultHeaderPadding,
    { sort: _vm.column.sortable },
    _vm.tableStyle,
    _vm.column.cellClass ],attrs:{"role":"columnheader","data-testid":'table-header-' + _vm.column.key},on:{"click":_vm.onSort}},[(!_vm.column.hideHeader)?_c('div',[_vm._t(((_vm.column.key) + "Header")),[_vm._v(_vm._s(_vm.column.label))],(_vm.showSortIcon)?_c('sort-icon',{attrs:{"dir":_vm.sort && _vm.sort.dir}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }